/* eslint-disable */
const mutations = {
  setCheckoutMethods(state, { checkoutMethods }) {
    state.data = checkoutMethods;
  },
};

export default mutations;
